import React from "react";
import Navbar from "../../Components/Common/Navbar";
import { Grid2, Toolbar } from "@mui/material";
import MaContainer from "../../Components/Common/container";
import { LuChevronRight } from "react-icons/lu";
import { useQuery } from "@apollo/client";
import { GET_PRODUCT_ORIGINS } from "../../Utils/Queries";
import Footer from "../../Components/Common/Footer";
import { useNavigate } from "react-router-dom";

const ExploreCulture = () => {
  const { data, loading, error } = useQuery(GET_PRODUCT_ORIGINS);

  const productOrigins = data?.searchProductOrigins?.items || [];

   const navigate = useNavigate();
  
    const handleNavigate = (name, id) => {
      navigate(`/product-origins/${name}/${id}`);
    };
  
  return (
    <div className="bg-[#F8F8F8]">
      <Navbar />
      <MaContainer>
        <div className="pt-10 ">
          <div className="flex items-center gap-x-3">
            <span className="text-[14px] text-[#727272]">Home</span>
            <LuChevronRight className="text-[#71747E] text-[12px]" />
            <span className="text-[14px] text-[#727272]">Explore Culture</span>
          </div>

          <h3>Explore Culture</h3>
        </div>
      </MaContainer>

      <div className="bg-white mt-6 py-10">
        <MaContainer>
          <Grid2 container spacing={2}>
            {productOrigins?.map((origin, idx) => (
              <Grid2 size={{ lg: 2, md: 3, sm: 4, xs: 6 }}>
                <div
                  onClick={() => handleNavigate(origin.name, origin?._id)}
                  className="bg-[#F8F8F8] rounded-[16px] py-8 flex cursor-pointer hover:shadow-md transition-all flex-col items-center justify-center"
                >
                  <img src={origin?.flagUrl} className="w-[50px] h-[50px]" />
                  <span className="text-[#181818] mt-2 font-[600] text-[13px]">
                    {" "}
                    {origin?.name}
                  </span>
                  <span className="text-[#9D9FA4] text-[11px] mt-1">
                    {" "}
                    {origin?.productCount ? origin.productCount + " " : 0 + " "}
                    Products
                  </span>
                </div>
              </Grid2>
            ))}
          </Grid2>
        </MaContainer>
      </div>
      <Footer />
    </div>
  );
};

export default ExploreCulture;
